import axios from "axios";

const api = axios.create({
  baseURL: "https://backend.elveescrubs.com/688787d8ff144c502c7f5cffaafe2cc588d86079f9de88304c26b0cb99ce91c6/api/",
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const token =
    localStorage.getItem("access") || sessionStorage.getItem("access");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refresh =
          localStorage.getItem("refresh") || sessionStorage.getItem("refresh");
        if (!refresh) throw new Error("No refresh token");

        const res = await axios.post(
          "https://backend.elveescrubs.com/688787d8ff144c502c7f5cffaafe2cc588d86079f9de88304c26b0cb99ce91c6/api/users/token/refresh/",
          { refresh }
        );

        const newAccess = res.data.access;

        if (localStorage.getItem("refresh")) {
          localStorage.setItem("access", newAccess);
        } else {
          sessionStorage.setItem("access", newAccess);
        }

        originalRequest.headers["Authorization"] = `Bearer ${newAccess}`;
        return api(originalRequest);
      } catch (refreshError) {
        console.error("Refresh token expired:", refreshError);

        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/login-register";
      }
    }

    return Promise.reject(error);
  }
);

export default api;
